var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert-triangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.449707,
    y: 0.482422,
    width: 24,
    height: 24,
    rx: 8,
    fill: "#F7CDCD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6907 5.74455L4.20522 16.6799C4.07151 16.9138 4.00075 17.179 4.00001 17.449C3.99926 17.7191 4.06854 17.9847 4.20095 18.2193C4.33337 18.4539 4.52431 18.6495 4.75477 18.7864C4.98523 18.9234 5.24718 18.997 5.51456 19H18.4854C18.7528 18.997 19.0148 18.9234 19.2452 18.7864C19.4757 18.6495 19.6666 18.4539 19.799 18.2193C19.9315 17.9847 20.0007 17.7191 20 17.449C19.9992 17.179 19.9285 16.9138 19.7948 16.6799L13.3093 5.74455C13.1728 5.51726 12.9806 5.32935 12.7513 5.19893C12.522 5.06851 12.2632 5 12 5C11.7368 5 11.478 5.06851 11.2487 5.19893C11.0194 5.32935 10.8272 5.51726 10.6907 5.74455Z",
    stroke: "#F16060",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 9V13",
    stroke: "#F16060",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12 16.4805H12.01",
    stroke: "#F16060",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/AlertTriangle.c1e6aab20b6e83998dc0b2b20f08704f.svg";
export { ForwardRef as ReactComponent };